const GoogleMapIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M14.8999 10.9831H14.9041C14.9041 10.9831 13.3333 13.2873 12.0124 14.9998C10.8708 16.479 10.5374 17.7456 10.4416 18.3581C10.4041 18.5831 10.2208 18.7498 9.99994 18.7498C9.7791 18.7498 9.59577 18.5831 9.55827 18.3581C9.46244 17.7456 9.1291 16.479 7.98744 14.9998C7.81244 14.7706 7.63327 14.5331 7.4541 14.2915L11.7666 9.16647L15.2374 5.0498C15.6208 5.85397 15.8333 6.75397 15.8333 7.70814C15.8333 8.91647 15.4874 10.0373 14.8999 10.9831Z"
        fill="#48B564"
      />
      <path
        d="M11.7666 9.16667L7.4541 14.2917C6.2791 12.7167 5.09577 10.9833 5.09577 10.9833H5.09993C4.97493 10.7833 4.86243 10.5792 4.7666 10.3667L8.23327 6.25C7.9041 6.64583 7.70827 7.15417 7.70827 7.70833C7.70827 8.975 8.73327 10 9.99994 10C10.7124 10 11.3499 9.675 11.7666 9.16667Z"
        fill="#FCC60E"
      />
      <path
        d="M11.8335 1.97484L8.26263 6.2165L5.5293 3.83317C6.59596 2.50817 8.2043 1.6665 10.0001 1.6665C10.6418 1.6665 11.2585 1.77484 11.8335 1.97484Z"
        fill="#2C85EB"
      />
      <path
        d="M8.26283 6.21683L8.23366 6.25016L4.76699 10.3668C4.38366 9.56266 4.16699 8.66266 4.16699 7.7085C4.16699 6.2335 4.67949 4.87933 5.52949 3.8335L8.26283 6.21683Z"
        fill="#ED5748"
      />
      <path
        d="M11.7667 9.16676C12.0959 8.77093 12.2917 8.2626 12.2917 7.70843C12.2917 6.44176 11.2667 5.41676 10.0001 5.41676C9.28756 5.41676 8.65007 5.74176 8.2334 6.2501L11.8334 1.9751C13.3292 2.48343 14.5542 3.60426 15.2376 5.0501L11.7667 9.16676Z"
        fill="#5695F6"
      />
    </svg>
  );
};
export default GoogleMapIcon;
